import React from 'react';

import { connect, useDispatch } from 'react-redux';
import { useIntl, defineMessages } from 'react-intl';

import { createSelectorCreator, defaultMemoize } from 'reselect';
import Tooltip from '@material-ui/core/Tooltip';
import lodash from 'lodash';

import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

import { IconVideo, IconMicrophone, IconMicrophoneOff } from '../IconSet';
import IconButton from '@material-ui/core/IconButton';
import useStyles from '../../style/ControlButton';

import { State as RoomState } from '../../lib/reducers/room';
import { State as WebsocketState } from '../../lib/reducers/websocket';
import { muteAll, unMuteAll, toggleVideoMute, } from '../../lib/actions/room';



const messages = defineMessages({
  muteAllButton: { id: 'muteAllButton' },
  unMuteAllButton: { id: 'unMuteAllButton' },
  muteAllVideos: { id: 'muteAllVideos' },
});


function Header(props: ExtendedProps) {
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();
  const authorized = ['room_owner', 'room_moderator'].includes(props.myRole);
  const disabled = props.isRequestingAllAudioMute;
  const classes = useStyles();

  const muteAllCmd = React.useCallback(
    () => dispatch(muteAll())
    , [dispatch]
  );

  const unMuteAllCmd = React.useCallback(
    () => dispatch(unMuteAll())
    , [dispatch]
  );

  const muteAllVideos = React.useCallback(
    () => props.others.forEach(
      (user) => dispatch(toggleVideoMute(user, true)))
    , [dispatch, props]
  );

  return (
    <ListItem>
      <ListItemText primary={props.headerText} />
      {authorized &&
        <Tooltip placement="top" title={formatMessage(messages.muteAllButton)}>
          <IconButton size='small' disabled={disabled} onClick={muteAllCmd} className={classes.controlButton}>
            <IconMicrophoneOff size={24} />
          </IconButton>
        </Tooltip>
      }
      {authorized &&
        <Tooltip placement="top" title={formatMessage(messages.unMuteAllButton)}>
          <IconButton size='small' disabled={disabled} onClick={unMuteAllCmd} className={classes.controlButton}>
            <IconMicrophone size={24} />
          </IconButton>
        </Tooltip>

      }
      <Tooltip placement="top" title={formatMessage(messages.muteAllVideos)}>
        <IconButton size='small' onClick={muteAllVideos} className={classes.controlButton}>
          <IconVideo size={24} />
        </IconButton>
      </Tooltip>
    </ListItem >
  );
}


type State = {
  room: RoomState;
  websocket: WebsocketState;
}


type MappedProps = {
  myRole: string;
  isRequestingAllAudioMute: boolean;
  users: Array<string>;
  others: Array<string>;
}


type Props = {
  headerText: string;
}

type ExtendedProps = Props & MappedProps;


const createDeepEqualSelector = createSelectorCreator(
  defaultMemoize,
  lodash.isEqual
);

const getUsers = (state: State) => {
  const roster = state.room.roster;
  return Object.keys(roster);
};

const mapUsers = createDeepEqualSelector(getUsers, (u) => u || {});

const getMyUid = (state: State) => {
  return (state.websocket || {}).uid;
};

const getOtherMembers = createDeepEqualSelector(
  getUsers,
  getMyUid,
  (users, me) => users.filter(u => u !== me)
);

const mapStateToProps = (state: State): MappedProps => {

  const user = state.websocket.uid;
  let myRole = '';
  let isRequestingAllAudioMute = false;
  if (user) {
    myRole = (state.room.roster[user] || { myRole: '' }).role;
    isRequestingAllAudioMute = (state.room.roster[user] ||
      { isRequestingAllAudioMute: false }).isRequestingAllAudioMute;
  }
  return ({ myRole, isRequestingAllAudioMute, others: getOtherMembers(state), users: mapUsers(state) });
};


export default connect(mapStateToProps)(Header);
